<template>
  <div :class="['reportDetails', isCousePage && !getMenuWay && 'hasM']" @click="closePop">
    <div class="container flex-center">
      <div class="module">
        <div class="mTitle flex-center">
          <h1>练习报告详情</h1>
          <span class="time">任务创建时间：{{details?.createTimeOutput}}</span>
        </div>
        <div class="courseTit line1">{{details.title}}</div>
        <div class="itemTit flex-center">
          <h2>班级信息</h2>
          <span class="grade" v-show="details?.classes?.name">{{details?.classes?.name.includes('年级') ? details?.classes?.name : details?.classes?.gradeOutput + details?.classes?.name}}</span>
        </div>
        <div class="infoBox flex-center">
          <p class="item flex-v" v-for="(item, i) of classInfo" :key="i">
            <span class="lab"><span class="num">{{(item.isClass ? details?.classes?.[item.key] : details[item.key]) || 0}}</span>人</span>
            <span class="txt">{{item.txt}}</span>
          </p>
        </div>
        <div class="itemTit flex-center"><h2>班级情况</h2></div>
        <div class="situation flex">
          <div class="box">
            <div class="boxTit">测评评价平均分</div>
            <div class="comWrap flex-v">
              <h1>{{homeworkOpts?.totalLevel || '-'}}</h1>
              <span :class="['score', !details.doneCnt && 'none']">{{`${details.doneCnt ? `${homeworkOpts?.totalScore}分` : '无人提交，未有成绩'}`}}</span>
              <span class="tips flex-center" v-if="homeworkOpts?.totalScore != homeworkOpts?.lastScore && homeworkOpts?.lastScore != null">
                较第一次练习{{homeworkOpts?.totalScore - homeworkOpts?.lastScore > 0 ? `提升了` : `降低了`}}{{Math.abs(homeworkOpts?.totalScore - homeworkOpts.lastScore)}}分
                <span :class="['icon', homeworkOpts?.totalScore - homeworkOpts?.lastScore < 0 && 'icon_down']"></span>
              </span>
            </div>
          </div>
          <div class="box box2">
            <div class="topWrap flex-center">
              <div class="boxTit">维度平均分</div>
              <div class="tips flex-center" @click.stop="openProp(1)">详情 <span class="iconfont a-jingshigantanhao"></span></div>
            </div>
            <div id="chartMain" class="chartBox"></div>
            <!-- 班级分数详情弹窗 -->
            <ToastProp :value="toastType === 1" width="100%" @closePop="closePop">
              <div class="scoreDetail">
                <div class="item" v-for="(item, i) in classesScore" :key="i">
                  <p>{{item.txt}}: {{homeworkOpts[item.level]}}（{{homeworkOpts[item.score]}}分）</p>
                  <div class="det flex-center" v-if="item?.itemScore">
                    <span  v-for="(v, k) of item.itemScore" :key="v">{{k}}: {{homeworkOpts[v]}}</span>
                  </div>
                </div>
              </div>
            </ToastProp>
          </div>
        </div>
        <div class="summary">
          <div class="boxTit">情况小结</div>
          <p :class="!homeworkOpts?.summary && 'none'">{{homeworkOpts?.summary || '暂时未有同学提交练习，可以在通知下所有同学，按时提交哦~'}}</p>
        </div>

         <!-- 榜单分数详情弹窗 -->
        <ToastProp :value="[3, 4].includes(toastType)" width="870px" left="0" top="" bottom="0" @closePop="closePop">
          <div class="uInfo flex-center">
            <img class="img" :src="opusReDetail?.photo" alt="">
            <span>{{opusReDetail?.studentName}}</span>
          </div>
          <div class="rankProp flex-center">
            <div class="scoreDetail">
              <!-- <div class="flex-center voiceBox" :class="{ 'last': toastType === 3}">
                <div class="cInfo flex-v">
                  <span class="line1">{{details?.title}}</span>
                  <span class="time">{{opusReDetail?.lastReport?.createTime}}</span>
                </div>
                <span @click.stop="onPlaying(opusReDetail?.lastReport)" :class="['iconfont flex-center', playSrc === opusReDetail?.lastReport?.voiceUrl && isPlaying ? 'xingzhuangjiehe2' : 'lujing1']"></span>
              </div> -->
              <div :class="['item rItem', !i && 'item1 title', !i && toastType === 3 && 'retTit']" v-for="(item, i) in classesScore" :key="i">
                <p :class="!i ? (toastType === 3 ? 'retProg' : 'prog') : ''">{{item.txt}}: {{opusReDetail?.lastReport?.[item.level]}}（{{opusReDetail?.lastReport?.[item.score]}}分）</p>
                <div class="det flex-center" v-if="item?.itemScore">
                  <span  v-for="(v, k) of item.itemScore" :key="v">{{k}}: {{opusReDetail?.lastReport?.[v]}}</span>
                </div>
              </div>
              <div class="opus">
                <div :class="['title', toastType === 3 && 'retTit']">作品详情</div>
                <div class="videoBox" v-if="opusReDetail?.opusType === 'mp4'">
                  <p class="opTitle">{{opusReDetail?.title}}</p>
                  <div class="videoImg" @click.stop="onPlaying(opusReDetail)">
                    <img class="img" :src="opusReDetail?.imageUrl" alt="">
                    <span class="iconfont flex-center lujing1"></span>
                  </div>
                </div>
                <div class="flex-center voiceBox" v-else :class="{ 'last': toastType === 3}">
                  <div class="cInfo flex-v">
                    <span class="line1">{{details?.title}}</span>
                    <span class="time">{{opusReDetail?.lastReport?.createTime}}</span>
                  </div>
                  <span @click.stop="onPlaying(opusReDetail?.lastReport)" :class="['iconfont flex-center', playSrc === opusReDetail?.lastReport?.voiceUrl && isPlaying ? 'xingzhuangjiehe2' : 'lujing1']"></span>
                </div>
              </div>
            </div>
              <div class="scoreDetail">
                <!-- <div class="flex-center voiceBox" :class="{ 'last': toastType === 4}">
                  <div class="cInfo flex-v">
                    <span class="line1">{{details?.title}}</span>
                    <span class="time">{{opusReDetail?.report?.createTime}}</span>
                  </div>
                  <span @click.stop="onPlaying(opusReDetail?.report)" :class="['iconfont flex-center', playSrc === opusReDetail?.report?.voiceUrl && isPlaying ? 'xingzhuangjiehe2' : 'lujing1']"></span>
                </div> -->
              <div :class="['item rItem', !i && 'item1 title', !i && toastType === 4 && 'retTit']" v-for="(item, i) in classesScore" :key="i">
                <p :class="!i ? (toastType === 4 ? 'retProg' : 'prog') : ''">{{item.txt}}: {{opusReDetail?.report?.[item.level]}}（{{opusReDetail?.report?.[item.score]}}分）</p>
                <div class="det flex-center" v-if="item?.itemScore">
                  <span  v-for="(v, k) of item.itemScore" :key="v">{{k}}: {{opusReDetail?.report?.[v]}}</span>
                </div>
              </div>
              <div class="opus">
                <div :class="['title', toastType === 4 && 'retTit']">作品详情</div>
                <div class="videoBox" v-if="opusReDetail?.report?.opusType === 'mp3'">
                  <p class="opTitle">{{opusReDetail?.report?.title}}</p>
                  <div class="videoImg" @click.stop="onPlaying(opusReDetail?.report)">
                    <img class="img" :src="opusReDetail?.report?.imageUrl" alt="">
                    <span class="iconfont flex-center lujing1"></span>
                  </div>
                </div>
                <div class="flex-center voiceBox" v-else :class="{ 'last': toastType === 4}">
                  <div class="cInfo flex-v">
                    <span class="line1">{{details?.title}}</span>
                    <span class="time">{{opusReDetail?.report?.createTime}}</span>
                  </div>
                  <span @click.stop="onPlaying(opusReDetail?.report)" :class="['iconfont flex-center', playSrc === opusReDetail?.report?.voiceUrl && isPlaying ? 'xingzhuangjiehe2' : 'lujing1']"></span>
                </div>
              </div>
            </div>
          </div>
        </ToastProp>
      </div>
      <div class="module module2">
        <div class="mTitle flex-center">
          <h1>班级学生名单</h1>
          <span class="time" v-if="details?.submitTimeOutput">提交截止时间：{{details.submitTimeOutput}}</span>
        </div>
        <div class="content">
          <div class="itemTit flex-center" v-if="progressRank.length || retrogressRank.length"><h2>学生名单</h2></div>
          <div :class="['stuList', btnIdx === 1 && (progressRank.length || retrogressRank.length) && 'noRank']">
            <div 
              class="stuItem flex-center" 
              v-for="item in studentList" 
              :key="item.id" 
              @click.stop="openProp(btnIdx === 2 ? 0 : 2,  item?.studentName || item?.student?.name, item?.photo || item?.user?.photo, item.id)"
            >
              <div class="avaBox" @click.stop="onPlaying(item)">
                <span v-if="btnIdx !== 2" :class="['iconfont flex-center', playSrc == item.voiceUrl && isPlaying ? 'xingzhuangjiehe2' : 'lujing1']"></span>
                <img :src="item?.photo || item?.user?.photo" alt="">
              </div>
              <p class="name line1">{{item?.studentName || item?.student?.name}}</p>
              <p class="score flex-v"  v-if="btnIdx === 1">
                <span class="lev">{{item.totalLevel}}</span>
                <span>{{item.totalScore}}分</span>
              </p>
            </div>
          </div>
          <!-- 个人作品分数详情弹窗 -->
          <ToastProp :value="toastType === 2"  width="442px" left="-420px" @closePop="closePop">
            <div class="scoreDetail">
              <div class="userInfo flex">
                <img class="avaImg" :src="opusReDetail?.photo" alt="">
                <span>{{opusReDetail?.studentName}}</span>
              </div>
              <div :class="['item', !i && 'item1 title']" v-for="(item, i) in classesScore" :key="i">
                <p>{{item.txt}}: {{opusReDetail[item.level]}}（{{opusReDetail[item.score]}}分）</p>
                <div class="det flex-center" v-if="item?.itemScore">
                  <span  v-for="(v, k) of item.itemScore" :key="v">{{k}}: {{opusReDetail[v]}}</span>
                </div>
              </div>
              <div class="opus">
                <div class="title">作品详情</div>
                <div class="videoBox" v-if="opusReDetail?.opusType === 'mp4'">
                  <p class="opTitle">{{opusReDetail?.title}}</p>
                  <div class="videoImg" @click.stop="onPlaying(opusReDetail)">
                    <img class="img" :src="opusReDetail?.imageUrl" alt="">
                    <span class="iconfont flex-center lujing1"></span>
                  </div>
                </div>
                <div class="flex-center voiceBox" v-else>
                  <div class="cInfo flex-v">
                    <span class="line1">{{opusReDetail?.title}}</span>
                    <span class="time">{{opusReDetail?.createTime}}</span>
                  </div>
                  <span @click.stop="onPlaying(opusReDetail)" :class="['iconfont flex-center',playSrc === opusReDetail?.voiceUrl && isPlaying ? 'xingzhuangjiehe2' : 'lujing1']"></span>
                </div>
              </div>
            </div>
          </ToastProp>
          <div class="rankBox flex" v-if="(progressRank.length || retrogressRank.length) && btnIdx != 2">
            <div :class="[retrogressRank.length ? 'box1' : 'box']" v-if="progressRank.length">
              <div class="itemTit flex-center">
                <h2 class="flex-center">进步榜 TOP 5<span class="icon"></span></h2>
              </div>
              <div class="stuList rankList">
                <div 
                  :class="['stuItem flex-center', retrogressRank.length && 'rankItem']"
                   v-for="(item, i) in progressRank"
                  :key="item.id"
                  @click.stop="openProp(3, item.studentName, item.photo, '', item.userId)"
                >
                  <span class="rank">{{i + 1}}</span>
                  <div class="avaBox">
                    <!-- <span :class="['iconfont flex-center', playSrc == item.voiceUrl && isPlaying ? 'xingzhuangjiehe2' : 'lujing1']"></span> -->
                    <img :src="item?.photo" alt="">
                  </div>
                  <p class="name line1">{{item?.studentName}}</p>
                  <p class="score flex-v last">
                    <span class="lev">{{item.lastLevel}}</span>
                    <span>{{item.lastScore}} 分</span>
                  </p>
                  <span class="sTo">→</span>
                  <p class="score flex-v">
                    <span class="lev">{{item.totalLevel}}</span>
                    <span>{{item.totalScore}} 分</span>
                  </p>
                </div>
              </div>
            </div>
            <div :class="[progressRank.length ? 'box1' : 'box']" v-if="retrogressRank.length">
              <div class="itemTit flex-center">
                <h2 class="flex-center">退步榜 TOP 5<span class="icon icon_down"></span></h2>
              </div>
              <div class="stuList rankList">
                <div 
                  :class="['stuItem flex-center', progressRank.length && 'rankItem']" 
                  v-for="(item, i) in retrogressRank" 
                  :key="item.id"
                  @click.stop="openProp(4, item.studentName, item.photo, '', item.userId)"
                >
                  <span class="rank">{{i + 1}}</span>
                  <div class="avaBox">
                    <!-- <span :class="['iconfont flex-center', playSrc == item.voiceUrl && isPlaying ? 'xingzhuangjiehe2' : 'lujing1']"></span> -->
                    <img :src="item?.photo" alt="">
                  </div>
                  <p class="name line1">{{item?.studentName}}</p>
                  <p class="score flex-v">
                    <span class="lev">{{item.lastLevel}}</span>
                    <span>{{item.lastScore}} 分</span>
                  </p>
                  <span class="sTo">→</span>
                  <p class="score flex-v last">
                    <span class="lev">{{item.totalLevel}}</span>
                    <span>{{item.totalScore}} 分</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <Empty class="empBox" v-if="isEmpty" title="还没有人提交练习作业哦～" tips="备注：可在小程序-班级管理- 对学生进行作业提交提醒"></Empty>
        </div>
        <div class="bott flex-center">
          <p :class="['btn', btnIdx === 1 && 'actBtn']" @click.stop="switchBtn(1)">已提交 {{details?.doneCnt || 0}}</p>
          <p :class="['btn', btnIdx === 2 && 'actBtn']" @click.stop="switchBtn(2)">未提交 {{details?.nodoneCnt || 0}}</p>
        </div>
      </div>
    </div>
    <video id="opusVideo" width="320" height="240" controls v-show="videoUrl"
      controlsList="nodownload noplaybackrate " disablePictureInPicture :src="videoUrl">
      您的浏览器不支持 HTML5 video 标签。
    </video>
  </div>
</template>

<script>
import ToastProp from "business/ToastProp";
import Empty from "business/Empty";
import audioMixin from "mixin/audio";
import * as echarts from "echarts/core";
import { TitleComponent, LegendComponent } from "echarts/components";
import { RadarChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";
echarts.use([TitleComponent, LegendComponent, RadarChart, CanvasRenderer]);
import { mapGetters } from 'vuex';

export default {
  mixins: [audioMixin],
  components: {
    ToastProp,
    Empty,
  },
  props: {
    homeworkId: {
      type: Number,
      default: null,
    },
    isCousePage: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      "getMenuWay",
    ]),
    isEmpty() {
      return (
        !this.studentList.length &&
        !this.progressRank.length &&
        !this.retrogressRank.length
      );
    },
  },
  data() {
    return {
      details: {}, // 作业详情
      homeworkOpts: {}, // 作业情况
      classInfo: [
        { key: "studentCnt", txt: "学生人数", isClass: 1 },
        { key: "doneCnt", txt: "提交练习人数" },
        { key: "nodoneCnt", txt: "未提交练习人数" },
      ],
      classesScore: [
        { txt: "综合得分", level: "totalLevel", score: "totalScore" },
        { txt: "完整度", level: "integrityLevel", score: "integrityScore" },
        {
          txt: "准确度",
          level: "pronLevel",
          score: "pronScore",
          itemScore: {
            声调分: "toneScore",
            平翘舌: "tongueScore",
            前后鼻音: "noseScore",
            音素分: "phonemeScore",
          },
        },
        { txt: "流利度", level: "fluencyLevel", score: "fluencyScore" },
        { txt: "朗读技巧", level: "skillLevel", score: "skillScore" },
        { txt: "情感表达", level: "emotionLevel", score: "emotionScore" },
      ],
      btnIdx: 1, // 按钮切换
      studentList: [], // 学生名单
      progressRank: [], // 进步榜单
      retrogressRank: [], // 退步榜单
      playSrc: null, // 当前播放的作品id
      toastType: null, // 1: 维度平均分， 2：学生名单作品， 3：榜单对比
      opusReDetail: {}, // 作品报告详情
      chartData: null,
      videoUrl: null, // 视频url
    };
  },
  methods: {
    initChart() {
      let {
        integrityScore,
        integrityLevel,
        fluencyScore,
        fluencyLevel,
        skillScore,
        skillLevel,
        emotionScore,
        emotionLevel,
        pronScore,
        pronLevel,
      } = this.homeworkOpts;
      let max = Math.min(
        100,
        Math.max(
          integrityScore,
          fluencyScore,
          skillScore,
          emotionScore,
          pronScore
        )
      );
      this.$nextTick(() => {
        this.chartData = echarts.init(document.getElementById("chartMain"));
        let option = {
          legend: {},
          radar: {
            center: ["50%", "57%"],
            radius: 64,
            indicator: [
              {
                name: "完整度",
                max: max || 10,
                score: integrityScore,
                level: integrityLevel,
              },
              {
                name: "流利度",
                max: max || 10,
                score: fluencyScore,
                level: fluencyLevel,
              },
              {
                name: "朗读技巧",
                max: max || 10,
                score: skillScore,
                level: skillLevel,
              },
              {
                name: "情感表达",
                max: max || 10,
                score: emotionScore,
                level: emotionLevel,
              },
              {
                name: "准确度",
                max: max || 10,
                score: pronScore,
                level: pronLevel,
              },
            ],
            axisName: {
              formatter: function(value, indicator) {
                console.log(value, indicator);
                let text = [];
                if (indicator.level)
                  text = [
                    `{lev|${indicator.level}} {num|${indicator.score}}`,
                    `{lab|${value}}`,
                  ];
                else text = [`{lev|-}`, `{lab|${value}}`];
                return text.join("\n");
              },
              rich: {
                lev: {
                  color: "#FB7C33",
                  lineHeight: 20,
                  fontSize: 17,
                  fontWeight: "bolder",
                },
                num: {
                  color: "#FB7C33",
                  lineHeight: 20,
                  fontSize: 10,
                },
                lab: {
                  fontSize: 10,
                  color: "#666666",
                },
              },
              align: "middle",
            },
            axisLine: {
              lineStyle: {
                color: "rgba(102, 102, 102, .1)",
                cap: "round",
              },
            },
            splitArea: {
              areaStyle: {
                color: "#FFFCF7",
              },
            },
            splitLine: {
              lineStyle: {
                color: "rgba(102, 102, 102, .1)",
              },
            },
          },
          series: [
            {
              type: "radar",
              symbol: "none",
              emphasis: {
                lineStyle: {
                  width: 1,
                },
              },
              data: [
                {
                  value: [
                    integrityScore,
                    fluencyScore,
                    skillScore,
                    emotionScore,
                    pronScore,
                  ],
                  areaStyle: {
                    color: "rgba(251, 124, 51, .3)",
                  },
                  lineStyle: {
                    color: "rgba(251, 124, 51, .3)",
                    join: "",
                    width: 0,
                  },
                },
              ],
            },
          ],
        };
        this.chartData.setOption(option);
      });
    },

    switchBtn(i) {
      if (this.btnIdx === i) return;
      this.btnIdx = i;
      this.getStudentList();
    },
    async openProp(type, studentName, photo, opusId, userId) {
      console.log(type);
      if (!type) return;
      this.toastType = type;
      let res = {};
      if (opusId) {
        if (this.opusReDetail?.id === opusId) return;
        res = await this.$get("/homework/opusReport.json", { opusId });
      }
      if (userId) {
        if (this.opusReDetail?.userId === userId) return;
        res = await this.$get("/homework/rankingReport.json", {
          homeworkId: this.homeworkId,
          userId,
        });
      }
      this.opusReDetail = { ...res.data, studentName, photo };
      console.log("----报告详情----", this.opusReDetail);
    },
    // 关闭分数详情弹窗
    closePop() {
      this.toastType = null;
    },
    // 作品播放
    onPlaying({ voiceUrl, opusType }) {
      if (opusType === 'mp4') {
        this.videoUrl = voiceUrl;
        const video = document.getElementById("opusVideo");
        if (video) {
          if (video.requestFullscreen) {
            video.requestFullscreen();
          } else if (video.mozRequestFullScreen) { // Firefox
            video.mozRequestFullScreen();
          } else if (video.webkitRequestFullscreen) { // Chrome, Safari and Opera
            video.webkitRequestFullscreen();
          } else if (video.msRequestFullscreen) { // IE/Edge
            video.msRequestFullscreen();
          }
        }
        return
      }
      this.videoUrl = null;
      this.changeStatus(voiceUrl, true);
      this.playSrc = voiceUrl;
    },
    async getDetail() {
      this.$loading.show();
      let params = { homeworkId: this.homeworkId };
      const infoRes = await this.$get("/homework/info.json", params);
      const situationRes = await this.$get("/homework/situation.json", params);
      if (infoRes.status == 200) this.details = infoRes.data || {};
      if (situationRes.status == 200)
        this.homeworkOpts = situationRes.data || {};
      this.$loading.hide();
      this.initChart();
      console.log(situationRes);
    },

    // 获取学生名单
    async getStudentList() {
      this.studentList = [];
      this.$loading.show();
      let apiUrl =
        this.btnIdx === 1
          ? "/homework/donelist.json"
          : "/homework/undolist.json";
      const res = await this.$get(apiUrl, { homeworkId: this.homeworkId });
      if (res.status == 200) {
        this.studentList = res.data || [];
      }
      this.$loading.hide();
      console.log(res);
    },
    // 获取榜单列表
    async getRankList() {
      const params = { homeworkId: this.homeworkId };
      const proRes = await this.$get("/homework/progress.json", params);
      const retRes = await this.$get("/homework/retrogress.json", params);
      if (proRes.status == 200) this.progressRank = proRes.data || [];
      if (retRes.status == 200) this.retrogressRank = retRes.data || [];
      console.log("----榜单----", proRes, retRes);
    },
  },

  mounted() {
    this.getDetail();
    this.getStudentList();
    this.getRankList();
    // 监听全屏变化事件
    const video = document.getElementById("opusVideo");
    video.addEventListener('fullscreenchange', () => {
      // // 检查是否退出全屏
      const isFullScreen = document.fullscreen || document.mozFullScreen || document.webkitIsFullScreen;
      if (!isFullScreen) {
        video.pause()
      } else {
        video.play();
      }
    });
  },
};
</script>

<style lang="less" scoped>
.reportDetails {
 height: 100%;
  width: 100%;
  padding: 0 50px;
  box-sizing: border-box;
  overflow: auto;

  // &.hasM{
  //   padding-left: 268px;
  // }

  .container {
    justify-content: space-between;
    align-items: stretch;
   height: 100%;
   width: 100%;
    // overflow-y: auto;
    // width: 80%;
    padding: 40px 0;
    box-sizing: border-box;
  }

  .module {
    width: 49%;
    min-height: 98%;
    background: #fffcf7;
    box-shadow: 0px 0px 10px 1px rgba(189, 94, 39, 0.05),
      inset 0px 0px 33px 10px rgba(255, 255, 255, 0.5);
    border-radius: 8px;
    padding: 36px;
    box-sizing: border-box;
    color: #333333;
    font-size: 16px;
    position: relative;

    &.module2 {
      // height: 90%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }

    .mTitle {
      justify-content: space-between;
      position: relative;
      border-bottom: 2px solid #999999;
      padding-bottom: 5px;
      box-sizing: border-box;

      &::after {
        content: "";
        width: 100%;
        height: 1px;
        background: #cccccc;
        position: absolute;
        bottom: -10px;
        left: 0;
      }

      h1 {
        color: #333333;
        font-size: 24px;
        font-weight: bold;
      }

      .time {
        color: #999999;
        font-size: 14px;
      }
    }

    .courseTit {
      width: 100%;
      height: 60px;
      background: #ffffff;
      box-shadow: 0px 0px 10px 1px rgba(189, 94, 39, 0.05);
      border-radius: 8px;
      line-height: 60px;
      text-align: center;
      font-size: 20px;
      margin-top: 30px;
    }

    .itemTit {
      justify-content: space-between;
      margin: 30px 0 20px;

      h2 {
        padding-left: 10px;
        font-size: 16px;
        font-weight: bold;
        position: relative;

        &::before {
          content: "";
          width: 3px;
          height: 10px;
          background: #FB7C33;
          border-radius: 2px;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }

      .grade {
        width: 140px;
        height: 49px;
        background: url("~images/底框@2x.png") no-repeat;
        background-size: contain;
        line-height: 56px;
        text-align: center;
        font-size: 20px;
      }
    }

    .icon {
      width: 17px;
      height: 17px;
      background: url("~images/提升@2x.png") no-repeat;
      background-size: 17px 17px;
      margin-left: 5px;

      &.icon_down {
        background: url("~images/ret_down.png") no-repeat;
        background-size: 17px 17px;
      }
    }

    .infoBox {
      justify-content: space-around;

      .item {
        align-items: center;

        .lab {
          color: #999999;
          font-size: 14px;

          .num {
            color: #FB7C33;
            font-size: 24px;
            margin-right: 5px;
          }
        }

        .txt {
          margin-top: 10px;
        }
      }
    }

    .boxTit {
      color: #666666;
      font-size: 14px;
      position: relative;
      display: inline-block;

      &::after {
        content: "";
        width: 100%;
        height: 12px;
        background: rgba(251, 124, 51, 0.1);
        border-radius: 6px;
        position: absolute;
        bottom: -5px;
        left: 30%;
      }
    }

    .situation {
      justify-content: space-between;

      .box {
        width: 46%;

        &.box2 {
          width: 50%;
          position: relative;
        }

        .comWrap {
          width: 100%;
          align-items: center;
          margin-top: 30px;
          min-height: 150px;
          justify-content: center;
          h1 {
            width: 100%;
            font-size: 60px;
            font-weight: bold;
            color: #FB7C33;
            background: url("~images/台子@2x.png") no-repeat;
            background-size: 100px 36px;
            background-position: center bottom;
            text-align: center;
            padding-bottom: 10px;
            box-sizing: border-box;
          }

          .score {
            font-size: 14px;
            margin-top: 5px;

            &.none {
              color: #999999;
              font-size: 10px;
            }
          }

          .tips {
            color: #999999;
            font-size: 10px;
          }
        }

        .topWrap {
          justify-content: space-between;

          .tips {
            font-size: 14px;
            color: #666666;
            cursor: pointer;

            .iconfont {
              color: #FB7C33;
              font-size: 16px;
              margin-top: 2px;
            }
          }
        }

        .chartBox {
          width: 100%;
          height: 200px;
          margin-top: 20px;
        }
      }
    }

    .rankProp {
      justify-content: space-between;
      position: relative;
      &::after {
        content: "";
        width: 2px;
        height: 308px;
        background: #eeeeee;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      > div {
        width: 47%;
      }
    }
    .uInfo {
      font-size: 20px;
      margin-bottom: 16px;
      .img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 10px;
      }
    }

    .scoreDetail {
      .voiceBox {
        // width: 283px;
        // height: 80px;
        width: 378px;
        height: 97px;
        background: #fffcf7;
        box-shadow: 0px 3px 8px 0px rgba(185, 143, 119, 0.2);
        border-radius: 8px;
        margin-bottom: 24px;
        justify-content: space-between;
        padding: 20px;
        box-sizing: border-box;

        .cInfo {
          overflow: hidden;
          font-size: 20px;
        }

        .time {
          color: #666666;
          font-size: 16px;
          margin-top: 8px;
        }

        .iconfont {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: #FB7C33;
          flex-shrink: 0;
          color: #ffffff;
        }

        &.last {
          .iconfont {
            background: #da9c75;
          }
        }
      }
      .userInfo {
        align-items: center;
        margin-bottom: 10px;
        font-size: 24px;

        .avaImg {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          margin-right: 16px;
        }
      }
      .item {
        p {
          font-size: 18px;
          font-weight: bold;
          margin-top: 10px;
        }
        .retProg {
          color: #da9c75;
        }
        .prog {
          color: #FB7C33;
        }
        &.item1 {
          p {
            font-size: 20px;
            margin-top: 0;
          }
        }

        &.rItem {
          padding-left: 20px;
          box-sizing: border-box;
        }

        .det {
          width: 100%;
          justify-content: flex-start;
          flex-wrap: wrap;
          color: #999999;
          font-size: 16px;

          span {
            line-height: 30px;
            min-width: 20%;
            margin-right: 30px;
          }
        }
      }
      .opus{
        margin-top: 16px;

        .videoBox{
          .opTitle{
            font-size: 16px;
            margin-bottom: 10px;
          }

          .videoImg{
            width: 303px;
            height: 170px;
            // box-shadow: 0px 4px 11px 0px rgba(185,143,119,0.2);
            background: #000000;
            border-radius: 5px;
            position: relative;
            overflow: hidden;

            .img{
              width: 100%;
              height: 100%;
              object-fit: contain;
            }

            .iconfont{
              width: 54px;
              height: 54px;
              background: rgba(0, 0, 0, 0.3);
              color: #ffffff;
              font-size: 18px;
              border-radius: 50%;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
      }
      .title{
        color: #333333;
        font-weight: bold;
        font-size: 20px;
        padding-left: 15px;
        box-sizing: border-box;
        position: relative;
        margin-bottom: 16px;


       &::before {
         content: "";
          width: 4px;
          height: 11px;
          background: #00bc0a;
          border-radius: 3px;
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
        }
      &.retTit{
        &::before{
          content: '';
          background: #da9c75;
        }
      }
      
      }
    }

    .summary {
      margin-top: 20px;

      p {
        margin-top: 20px;
        font-size: 14px;
        color: #333333;

        &.none {
          color: #cccccc;
        }
      }
    }

    .content {
      // height: calc(100% - 128px);
      margin-top: 30px;
      width: 100%;
      // position: relative; 
      flex: 1;
      flex-shrink: 1;
      overflow: auto; 

      .rankBox {
        width: 100%;
        justify-content: space-between;

        .box {
          flex: auto;
        }
        .box1 {
          width: 50%;
        }
      }

      .stuList {
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        width: 100%;
        overflow-y: auto;
        position: relative;
        // max-height: 82%;
        height: auto;

        &.noRank {
          height: 270px;
          max-height: auto;
        }

        &.rankList {
          // max-height: 200px;
          // height: auto;
          margin-right: 10px;
          padding-bottom: 80px;
          box-sizing: border-box;
        }
        .stuItem {
          width: 48%;
          height: 60px;
          background: #ffffff;
          box-shadow: 0px 0px 10px 1px rgba(189, 94, 39, 0.05);
          border-radius: 8px;
          margin: 0 10px 10px 0;
          justify-content: flex-start;
          padding: 10px 16px;
          box-sizing: border-box;
          cursor: pointer;

          &.rankItem {
            width: 98%;
            margin-right: 0;
          }

          &:nth-child(2n) {
            margin-right: 0;
          }

          .rank {
            margin-right: 10px;
            flex-shrink: 0;
          }

          .avaBox {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            overflow: hidden;
            position: relative;
            margin-right: 16px;
            flex-shrink: 0;
            cursor: pointer;

            .iconfont {
              width: 100%;
              height: 100%;
              background: rgba(0, 0, 0, 0.3);
              color: #ffffff;
              font-size: 14px;
              border-radius: 50%;
              position: absolute;
              top: 0;
              left: 0;
            }

            img {
              width: 100%;
              height: 100%;
            }
          }

          .name {
            flex: auto;
            margin-right: 10px;
          }

          .score {
            color: #FB7C33;
            font-size: 12px;
            flex-shrink: 0;
            margin-left: 10px;
            align-items: center;

            .lev {
              font-size: 24px;
              font-weight: bold;
            }

            &.last {
              color: #da9c75;
            }
          }

          .sTo {
            font-weight: bold;
            color: #cccccc;
            margin: 0 5px;
          }
        }
      }
    }

    .bott {
      width: 100%;
      height: 98px;
      // position: absolute;
      // bottom: 0;
      p {
        width: 150px;
        height: 40px;
        background: rgba(251, 124, 51, 0.1);
        color: #FB7C33;
        border-radius: 20px;
        cursor: pointer;
        &:first-child {
          margin-right: 24px;
        }
        &.actBtn {
          background: #FB7C33;
          color: #ffffff;
        }
      }
    }
  }

  #opusVideo{
    position: fixed;
    top: -100%;
    right: -100%;
  }
}
</style>


